module.exports = __webpack_public_path__ + "static/media/conflict2e2161cfa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/conflict2.svg
// module id = 1322
// module chunks = 0